import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import { useSEO } from '../hooks/useSEO';
import ProductHero from '../components/ProductHero';

const ROUTES = [
  { industry: 'Healthcare', to: '/videra/healthcare', product: 'Videra Healthcare' },
  { industry: 'Facilities Management / Hard Services', to: '/videra/hard-services', product: 'Videra Hard Services' },
  { industry: 'PFI / P3 / PPP', to: '/videra/vanguard', product: 'Vanguard + Hard Services + Handback' },
  { industry: 'Construction', to: '/videra/construction', product: 'Videra Construction' },
  { industry: 'Fire Safety', to: '/firestopping', product: 'SafeTrace + Firestopping Business Dashboard' },
  { industry: 'IT & Digital', to: '/videra/pm', product: 'Videra PM' },
  { industry: 'Pharmaceutical', to: '/videra/pm', product: 'Videra PM' },
  { industry: 'Manufacturing', to: '/videra/pm', product: 'Videra PM' },
  { industry: 'Energy & Utilities', to: '/videra/pm', product: 'Videra PM' },
  { industry: 'Property & Infrastructure', to: '/videra/pm', product: 'Videra PM' },
  { industry: 'Other Industries', to: '/videra/pm', product: 'Videra PM / Keystone' },
];

const V2Industries = () => {
  useSEO({
    title: 'Industries | Videra by sector',
    description: 'Route to the right Videra solution for your sector — Healthcare, FM, PFI/P3, Construction, Fire Safety, IT, Pharma, Manufacturing, Energy and more.',
    path: '/industries',
  });

  return (
    <div data-testid="v2-industries">
      <ProductHero
        eyebrow="Industries"
        title="Different industries. The same need for better control."
        body="Every sector has its own vocabulary and constraints. The underlying need to connect projects, lifecycle, assurance and evidence is remarkably consistent. Find the right Videra route for your world."
        testid="industries-hero"
      />

      <section className="py-16 md:py-20 bg-slate-50 border-y border-slate-200">
        <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8">
          <ul className="divide-y divide-slate-200 border border-slate-200 rounded-xl bg-white">
            {ROUTES.map((r) => (
              <li key={r.industry}>
                <Link to={r.to} className="flex items-center justify-between px-6 py-4 hover:bg-slate-50 transition-colors group" data-testid={`industry-row-${r.industry.toLowerCase().replace(/\W+/g,'-')}`}>
                  <div>
                    <p className="text-base font-medium text-slate-900">{r.industry}</p>
                    <p className="text-xs text-slate-500 mt-0.5">Suggested route: {r.product}</p>
                  </div>
                  <ArrowRight className="w-4 h-4 text-slate-400 group-hover:text-blue-600 group-hover:translate-x-0.5 transition-all" />
                </Link>
              </li>
            ))}
          </ul>
        </div>
      </section>
    </div>
  );
};

export default V2Industries;
